import React, { useState, useEffect } from 'react';
import './SavedMessages.css';

function SavedMessages({ onClose, selectedChat, socket }) {
  const [messages, setMessages] = useState([]);
  const [newMessageTitle, setNewMessageTitle] = useState('');
  const [newMessageContent, setNewMessageContent] = useState('');
  const [showAddForm, setShowAddForm] = useState(false);
  const [editingId, setEditingId] = useState(null);

  // טעינת הודעות מ-localStorage
  useEffect(() => {
    const savedMessages = localStorage.getItem('whatsapp_saved_messages');
    if (savedMessages) {
      setMessages(JSON.parse(savedMessages));
    }
  }, []);

  // שמירת הודעות ב-localStorage
  const saveToLocalStorage = (msgs) => {
    localStorage.setItem('whatsapp_saved_messages', JSON.stringify(msgs));
  };

  // הוספת הודעה חדשה
  const handleAddMessage = () => {
    if (!newMessageTitle.trim() || !newMessageContent.trim()) {
      alert('נא למלא כותרת ותוכן הודעה');
      return;
    }

    if (editingId) {
      // עריכת הודעה קיימת
      const updatedMessages = messages.map(msg =>
        msg.id === editingId ? { ...msg, title: newMessageTitle, content: newMessageContent } : msg
      );
      setMessages(updatedMessages);
      saveToLocalStorage(updatedMessages);
      setEditingId(null);
    } else {
      // הוספת הודעה חדשה
      const newMessage = {
        id: Date.now(),
        title: newMessageTitle,
        content: newMessageContent,
        createdAt: new Date().toISOString()
      };
      const updatedMessages = [...messages, newMessage];
      setMessages(updatedMessages);
      saveToLocalStorage(updatedMessages);
    }

    setNewMessageTitle('');
    setNewMessageContent('');
    setShowAddForm(false);
  };

  // מחיקת הודעה
  const handleDeleteMessage = (id) => {
    if (!window.confirm('האם למחוק הודעה זו?')) return;

    const updatedMessages = messages.filter(msg => msg.id !== id);
    setMessages(updatedMessages);
    saveToLocalStorage(updatedMessages);
  };

  // עריכת הודעה
  const handleEditMessage = (msg) => {
    setNewMessageTitle(msg.title);
    setNewMessageContent(msg.content);
    setEditingId(msg.id);
    setShowAddForm(true);
  };

  // שליחת הודעה לתלמיד
  const handleSendMessage = (content) => {
    if (!selectedChat) {
      alert('נא לבחור תלמיד קודם');
      return;
    }

    const confirmed = window.confirm(`האם לשלוח את ההודעה ל-${selectedChat.name}?`);
    if (!confirmed) return;

    if (socket) {
      socket.emit('send_message', {
        chatId: selectedChat.id,
        body: content
      });

      socket.once('message_sent', (result) => {
        if (result.success) {
          alert('ההודעה נשלחה בהצלחה!');
        } else {
          alert('שגיאה בשליחת ההודעה');
        }
      });
    }
  };

  return (
    <div className="saved-messages-overlay" onClick={onClose}>
      <div className="saved-messages-panel" onClick={(e) => e.stopPropagation()}>
        <div className="saved-messages-header">
          <h2>💬 הודעות שמורות</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="saved-messages-content">
          {!showAddForm ? (
            <>
              <button className="add-message-btn" onClick={() => setShowAddForm(true)}>
                + הוסף הודעה חדשה
              </button>

              <div className="messages-list">
                {messages.length === 0 ? (
                  <div className="empty-state">
                    <svg viewBox="0 0 24 24" width="64" height="64">
                      <path fill="#8696a0" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-2-2H7v-1h10v1zm0-2H7v-1h10v1zm0-2H7V9h10v4z"/>
                    </svg>
                    <p>אין הודעות שמורות</p>
                    <small>לחץ על "הוסף הודעה חדשה" כדי להתחיל</small>
                  </div>
                ) : (
                  messages.map(msg => (
                    <div key={msg.id} className="message-card">
                      <div className="message-card-header">
                        <h3>{msg.title}</h3>
                        <div className="message-actions">
                          <button className="edit-btn" onClick={() => handleEditMessage(msg)} title="ערוך">
                            ✏️
                          </button>
                          <button className="delete-btn" onClick={() => handleDeleteMessage(msg.id)} title="מחק">
                            🗑️
                          </button>
                        </div>
                      </div>
                      <div className="message-card-content">
                        <p>{msg.content}</p>
                      </div>
                      <button className="send-message-btn" onClick={() => handleSendMessage(msg.content)}>
                        📤 שלח לתלמיד
                      </button>
                    </div>
                  ))
                )}
              </div>
            </>
          ) : (
            <div className="add-message-form">
              <h3>{editingId ? 'ערוך הודעה' : 'הודעה חדשה'}</h3>

              <div className="form-group">
                <label>כותרת ההודעה</label>
                <input
                  type="text"
                  placeholder="לדוגמא: ברוכים הבאים"
                  value={newMessageTitle}
                  onChange={(e) => setNewMessageTitle(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label>תוכן ההודעה</label>
                <textarea
                  rows="8"
                  placeholder="הקלד את תוכן ההודעה כאן..."
                  value={newMessageContent}
                  onChange={(e) => setNewMessageContent(e.target.value)}
                />
              </div>

              <div className="form-buttons">
                <button className="cancel-btn" onClick={() => {
                  setShowAddForm(false);
                  setNewMessageTitle('');
                  setNewMessageContent('');
                  setEditingId(null);
                }}>
                  ביטול
                </button>
                <button className="save-btn" onClick={handleAddMessage}>
                  {editingId ? 'עדכן' : 'שמור'}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SavedMessages;
